module.exports = __webpack_public_path__ + "assets/logo.4e3c881e.svg";